// Dados mock organizados para protótipo - serão substituídos por dados reais do backend

export interface MockUser {
  id: string;
  name: string;
  email: string;
  clients: string[];
  createdAt: string;
  accessType: 'google' | 'password';
  status: 'active' | 'inactive' | 'pending';
  inviteSent?: boolean;
}

export interface MockClient {
  id: string;
  name: string;
  email: string;
  company: string;
  description: string;
  productIds: string[];
  productNames: string[];
  status: 'active' | 'inactive';
  createdAt: string;
}

export interface MockProduct {
  id: string;
  name: string;
  description: string;
  modelId: string;
  modelName: string;
  agentId: string;
  agentName: string;
  status: 'active' | 'inactive';
  createdAt: string;
}

export interface MockModel {
  id: string;
  name: string;
  description?: string;
  provider: string;
  type: 'text' | 'image' | 'multimodal';
}

export interface MockAgent {
  id: string;
  name: string;
  description?: string;
  type: 'text' | 'image' | 'analysis';
}

export interface MockWorkspace {
  id: string;
  name: string;
  description: string;
  clientId: string;
  clientName: string;
  productIds: string[];
  productNames: string[];
  userCount: number;
  status: 'active' | 'inactive';
  createdAt: string;
}

// Modelos disponíveis
export const mockModels: MockModel[] = [
  {
    id: '1',
    name: 'GPT-4',
    description: 'Modelo de linguagem avançado da OpenAI',
    provider: 'OpenAI',
    type: 'text'
  },
  {
    id: '2',
    name: 'Claude 3.5 Sonnet',
    description: 'Modelo de linguagem da Anthropic',
    provider: 'Anthropic',
    type: 'text'
  },
  {
    id: '3',
    name: 'Gemini Pro',
    description: 'Modelo multimodal do Google',
    provider: 'Google',
    type: 'multimodal'
  },
  {
    id: '4',
    name: 'DALL-E 3',
    description: 'Gerador de imagens da OpenAI',
    provider: 'OpenAI',
    type: 'image'
  },
];

// Agentes disponíveis
export const mockAgents: MockAgent[] = [
  {
    id: '1',
    name: 'Agente de Imagem',
    description: 'Especializado em geração e processamento de imagens',
    type: 'image'
  },
  {
    id: '2',
    name: 'Agente de Texto',
    description: 'Especializado em processamento de linguagem natural',
    type: 'text'
  },
  {
    id: '3',
    name: 'Agente de Análise',
    description: 'Especializado em análise de dados e documentos',
    type: 'analysis'
  },
  {
    id: '4',
    name: 'Agente Conversacional',
    description: 'Especializado em conversas e atendimento',
    type: 'text'
  },
];

// Especialistas mock
export const mockProducts: MockProduct[] = [
  {
    id: '1',
    name: 'Geração de Imagens IA',
    description: 'Especialista para geração de imagens usando inteligência artificial com prompts personalizados',
    modelId: '4',
    modelName: 'DALL-E 3',
    agentId: '1',
    agentName: 'Agente de Imagem',
    status: 'active',
    createdAt: '2024-01-15',
  },
  {
    id: '2',
    name: 'Análise de Documentos',
    description: 'Especialista para análise e processamento automatizado de documentos corporativos',
    modelId: '2',
    modelName: 'Claude 3.5 Sonnet',
    agentId: '3',
    agentName: 'Agente de Análise',
    status: 'active',
    createdAt: '2024-01-10',
  },
  {
    id: '3',
    name: 'Processamento de Texto',
    description: 'Solução para processamento e geração de textos automatizados',
    modelId: '1',
    modelName: 'GPT-4',
    agentId: '2',
    agentName: 'Agente de Texto',
    status: 'active',
    createdAt: '2024-01-08',
  },
  {
    id: '4',
    name: 'Reconhecimento de Voz',
    description: 'Especialista para conversão de áudio em texto e processamento de comandos',
    modelId: '3',
    modelName: 'Gemini Pro',
    agentId: '2',
    agentName: 'Agente de Texto',
    status: 'inactive',
    createdAt: '2024-01-05',
  },
  {
    id: '5',
    name: 'Chatbot Inteligente',
    description: 'Assistente virtual para atendimento ao cliente automatizado',
    modelId: '1',
    modelName: 'GPT-4',
    agentId: '4',
    agentName: 'Agente Conversacional',
    status: 'active',
    createdAt: '2024-01-03',
  },
  {
    id: '6',
    name: 'Análise de Sentimentos',
    description: 'Análise automática de sentimentos em textos e feedbacks',
    modelId: '2',
    modelName: 'Claude 3.5 Sonnet',
    agentId: '3',
    agentName: 'Agente de Análise',
    status: 'active',
    createdAt: '2024-01-01',
  },
];

// Clientes mock
export const mockClients: MockClient[] = [
  {
    id: '1',
    name: 'João Silva',
    email: 'joao.silva@techsolutions.com',
    company: 'Tech Solutions Ltda',
    description: 'Cliente corporativo focado em soluções de IA para automação de processos internos',
    productIds: ['1', '2'],
    productNames: ['Geração de Imagens IA', 'Análise de Documentos'],
    status: 'active',
    createdAt: '2024-01-15',
  },
  {
    id: '2',
    name: 'Maria Santos',
    email: 'maria.santos@startupx.com',
    company: 'StartupX Innovation',
    description: 'Startup focada em processamento de linguagem natural para análise de mercado',
    productIds: ['3', '5', '6'],
    productNames: ['Processamento de Texto', 'Chatbot Inteligente', 'Análise de Sentimentos'],
    status: 'active',
    createdAt: '2024-01-10',
  },
  {
    id: '3',
    name: 'Carlos Oliveira',
    email: 'carlos@digitalcorp.com',
    company: 'Digital Corp',
    description: 'Empresa de consultoria digital especializada em transformação tecnológica',
    productIds: ['1', '3', '5'],
    productNames: ['Geração de Imagens IA', 'Processamento de Texto', 'Chatbot Inteligente'],
    status: 'active',
    createdAt: '2024-01-08',
  },
];

// Usuários mock
export const mockUsers: MockUser[] = [
  {
    id: '1',
    name: 'João Silva',
    email: 'joao.silva@empresa.com',
    clients: ['Tech Solutions Ltda', 'StartupX Innovation'],
    createdAt: '2024-01-15',
    accessType: 'google',
    status: 'active'
  },
  {
    id: '2',
    name: 'Maria Santos',
    email: 'maria.santos@empresa.com',
    clients: ['Tech Solutions Ltda'],
    createdAt: '2024-01-14',
    accessType: 'password',
    status: 'pending',
    inviteSent: true
  },
  {
    id: '3',
    name: 'Carlos Oliveira',
    email: 'carlos.oliveira@empresa.com',
    clients: ['StartupX Innovation', 'Digital Corp'],
    createdAt: '2024-01-13',
    accessType: 'password',
    status: 'active'
  },
  {
    id: '4',
    name: 'Ana Costa',
    email: 'ana.costa@empresa.com',
    clients: ['Tech Solutions Ltda', 'StartupX Innovation', 'Digital Corp'],
    createdAt: '2024-01-12',
    accessType: 'google',
    status: 'active'
  }
];

// Workspaces mock
export const mockWorkspaces: MockWorkspace[] = [
  {
    id: '1',
    name: 'Atendimento ao Cliente',
    description: 'Workspace dedicado para equipe de atendimento ao cliente com chatbot e análise de sentimentos',
    clientId: '1',
    clientName: 'Tech Solutions Ltda',
    productIds: ['5', '6'],
    productNames: ['Chatbot Inteligente', 'Análise de Sentimentos'],
    userCount: 5,
    status: 'active',
    createdAt: '2024-01-20',
  },
  {
    id: '2',
    name: 'Marketing Digital',
    description: 'Workspace para equipe de marketing com geração de imagens e análise de documentos',
    clientId: '1',
    clientName: 'Tech Solutions Ltda',
    productIds: ['1', '2'],
    productNames: ['Geração de Imagens IA', 'Análise de Documentos'],
    userCount: 3,
    status: 'active',
    createdAt: '2024-01-18',
  },
  {
    id: '3',
    name: 'Desenvolvimento',
    description: 'Workspace para desenvolvedores com processamento de texto e chatbot',
    clientId: '2',
    clientName: 'StartupX Innovation',
    productIds: ['3', '5'],
    productNames: ['Processamento de Texto', 'Chatbot Inteligente'],
    userCount: 8,
    status: 'active',
    createdAt: '2024-01-15',
  },
  {
    id: '4',
    name: 'Análise de Dados',
    description: 'Workspace especializado em análise de dados e sentimentos',
    clientId: '3',
    clientName: 'Digital Corp',
    productIds: ['6', '2'],
    productNames: ['Análise de Sentimentos', 'Análise de Documentos'],
    userCount: 2,
    status: 'inactive',
    createdAt: '2024-01-12',
  },
];

// Lista de empresas/clientes para seleção
export const mockClientOptions = [
  'Tech Solutions Ltda',
  'StartupX Innovation',
  'Digital Corp',
  'Inovação Digital S.A.',
  'Future Tech Labs'
];

// Credenciais de teste para login (apenas para protótipo)
export const testCredentials = {
  admin: {
    email: 'admin@aimonitor.com',
    password: 'Admin@123'
  },
  manager: {
    email: 'gerente@aimonitor.com',
    password: 'Manager@123'
  },
  analyst: {
    email: 'analista@aimonitor.com',
    password: 'Analyst@123'
  }
};

// Configurações do protótipo
export const prototypeConfig = {
  maxRetries: 3,
  defaultTimeout: 5000,
  simulateNetworkDelay: true,
  simulateErrors: false, // Pode ser alterado para testar tratamento de erros
  enableLogging: true,
  version: '1.0.0-prototype'
};
